export default theme => ({
    accordion: {
        border: `2px solid ${theme.palette.grey[200]}`,
        marginBottom: 18,

        '& .MuiButtonBase-root': {
            '& p': {
                margin: '0!important',
                fontWeight: 700,
                textTransform: 'capitalize',
                fontSize: 16
            }
        }
    },
    historyRow: {
        display: 'flex',
        alignItems: 'center'
    },
    nameColumn: {
        width: '50%',
        fontWeight: 600,
        color: theme.palette.grey[900],
        '@media only screen and (max-width: 1200px)': {
            width: '40%'
        }
    },
    timeColumn: {
        width: '30%',
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.grey[500]
    },
    buttonColumn: {
        color: theme.palette.blue[500]
    },
    topDateLabel: {
        color: theme.palette.grey[500],
        fontSize: 12,
        marginBottom: 12
    },
    wrapper: {
        '& .performance-block': {
            padding: '0 30px 0 0',
            borderRight: `1px solid ${theme.palette.grey[200]}`,
            marginRight: 30
        }
    }
});
